module.exports = __webpack_public_path__ + "media/images/download-now-27fb0f3ebcb48abcd9157b5938187d8e.jpeg";